import { styled } from "@styles";

export const Wrapper = styled.div``;

export const AddressCard = styled.div`
  padding: 2rem 2rem 0 2rem;
  margin-bottom: 1rem;
  border: 1px solid black;
`;

export const AddressCardUl = styled.ul`
  text-align: right;
`;